/* The encoding is super important here to enable frame-by-frame scrubbing. */

// ffmpeg -i ~/Downloads/Toshiba\ video/original.mov -movflags faststart -vcodec libx264 -crf 23 -g 1 -pix_fmt yuv420p output.mp4
// ffmpeg -i ~/Downloads/Toshiba\ video/original.mov -vf scale=960:-1 -movflags faststart -vcodec libx264 -crf 20 -g 1 -pix_fmt yuv420p output_960.mp4

import { gsap } from 'gsap/dist/gsap';

export default function setScrollVideo() {
    const video = document.querySelector('.video-background');
    let videoElementTop = 0;
    let videoElementBottom = 0;
    let videoRefreshed = false;
    let firstScroll = false;
    const { src } = video;

    if (videoElementTop === 0) {
        // Get video offset positions
        videoElementTop = video.offsetTop - window.innerHeight;
        videoElementBottom = video.offsetTop;
        ScrollTrigger.refresh();
    }

    // Check for when to refresh -> when video container is almost in view
    document.addEventListener('scroll', function () {
        if (firstScroll === false) {
            console.log('first scroll');
            ScrollTrigger.refresh();
            firstScroll = true;
        }
        if (window._scrollTop() > videoElementTop - 200 && window._scrollTop() < videoElementBottom + 200) {
            if (!videoRefreshed) {
                console.log('refresh()');
                ScrollTrigger.refresh();
                videoRefreshed = true;
            }
        } else {
            // videoRefreshed = false;
        }
    });

    /* Make sure the video is 'activated' on iOS */
    function once(el, event, fn, opts) {
        var onceFn = function (e) {
            el.removeEventListener(event, onceFn);
            fn.apply(this, arguments);
        };
        el.addEventListener(event, onceFn, opts);
        return onceFn;
    }

    once(document.documentElement, 'touchstart', function (e) {
        video.play();
        video.pause();
    });

    /* ---------------------------------- */

    /* Scroll Control! */

    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.matchMedia({
        // desktop
        '(min-width: 767px)': function () {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: '#scrollVideoTrigger',
                    pin: true,
                    anticipatePin: 1,
                    start: 'top top',
                    end: 'bottom -750%',
                    scrub: 1,
                    preventOverlaps: true,
                    invalidateOnRefresh: true,
                    pinSpacing: true,
                    pinType: 'fixed',
                },
            });

            once(video, 'loadedmetadata', () => {
                tl.fromTo(
                    video,
                    {
                        currentTime: 0,
                    },
                    {
                        currentTime: video.duration || 1,
                        id: 'scrollVideoTimeline',
                    },
                );
            });

            // console.log(tl);
            // tl.restart();

            /* When first coded, the Blobbing was important to ensure the browser wasn't dropping previously played segments, but it doesn't seem to be a problem now. Possibly based on memory availability? */
            setTimeout(function () {
                if (window.fetch) {
                    fetch(src)
                        .then((response) => response.blob())
                        .then((response) => {
                            const blobURL = URL.createObjectURL(response);

                            const t = video.currentTime;
                            once(document.documentElement, 'touchstart', function (e) {
                                video.play();
                                video.pause();
                            });

                            video.setAttribute('src', blobURL);
                            video.currentTime = t + 0.01;
                        });
                }
            }, 1000);
        },
    });

    // ScrollTrigger.refresh();
}
